module.exports = __webpack_public_path__ + "static/img/shunfengshanLogo2.068caca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shunfengshanLogo2.jpg
// module id = S9Kf
// module chunks = 63